module.exports = __webpack_public_path__ + "media/images/global/icons/card-d92feb3b0568c8b70f137d3182d6836a.svg";